module.exports = __webpack_public_path__ + "static/media/logo-saurus.7ef26783.png";